export default __webpack_public_path__ + "static/media/img_about_content-1.94eabb9b.png";